import intl from "react-intl-universal";
import { TbAdjustmentsHorizontal, TbCalendar } from "react-icons/tb";
import { ModernFilterBar } from "../../../../../Components/Molecules/Filters/ModernFilterBar";
import {
  CheckboxListFilterPanel,
  DateFilterPanel,
} from "../../../../../Components/Molecules/Filters/ModernFilterPanels";
import {
  EMPTY_BAAS_ONBOARD_FILTERS,
  buildBaasOnboardFilterTags,
  getBaasOnboardStatusOptions,
  hasActiveBaasOnboardFilters,
  isBaasOnboardChipFilterActive,
  removeBaasOnboardFilterTag,
} from "../baasOnboardInvites";

export const BaasOnboardFilterBar = ({ filters, onFiltersChange, filteredItems }) => {
  const filterButtons = [
    {
      id: "date",
      icon: TbCalendar,
      label: intl.get("baas.entidades.quickActions.onboardFilterDate"),
      active: isBaasOnboardChipFilterActive(filters, "date"),
    },
    {
      id: "status",
      icon: TbAdjustmentsHorizontal,
      label: intl.get("baas.entidades.quickActions.onboardFilterStatus"),
      active: isBaasOnboardChipFilterActive(filters, "status"),
    },
  ];

  const renderPanelContent = (panelId, draft, onChange) => {
    switch (panelId) {
      case "date":
        return <DateFilterPanel draft={draft} onChange={onChange} />;
      case "status":
        return (
          <CheckboxListFilterPanel
            options={getBaasOnboardStatusOptions()}
            selectedValues={draft.statuses}
            onChange={(statuses) => onChange({ ...draft, statuses })}
            idPrefix="baas-onboard-status"
          />
        );
      default:
        return null;
    }
  };

  return (
    <ModernFilterBar
      filters={filters}
      onFiltersChange={onFiltersChange}
      emptyFilters={EMPTY_BAAS_ONBOARD_FILTERS}
      searchPlaceholder={intl.get("baas.entidades.quickActions.onboardSearchPlaceholder")}
      filterButtons={filterButtons}
      moreFiltersActive={false}
      buildFilterTags={buildBaasOnboardFilterTags}
      hasActiveFilters={hasActiveBaasOnboardFilters}
      removeFilterTag={removeBaasOnboardFilterTag}
      renderPanelContent={renderPanelContent}
      filteredItems={filteredItems}
      showExport={false}
      panelTitles={{
        date: intl.get("baas.entidades.quickActions.onboardFilterDate"),
        status: intl.get("baas.entidades.quickActions.onboardFilterStatus"),
      }}
    />
  );
};
